import { useState } from "react"
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
} from "@mui/material"
import "./index.css" // Renamed to a more generic name
import { emailValidateRegex, isValidPassword } from "../../utils/Helpers"
// import { getData, getLogin } from "../services/services";
import Loader from "../GlobalComponents/Loader"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setUserData } from "../../redux/reducer/appReducer"
import { getData, getLogin } from "../../services/services"
import { showToast } from "../GlobalComponents/Toast"
import { Visibility, VisibilityOff } from "@mui/icons-material"

function Login() {
  const [userName, setUserName] = useState("")
  const [password, setPassword] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const enableLogin = userName.length >= 3 && isValidPassword(password)
  // const enableLogin = emailValidateRegex.test(userName) && isValidPassword(password)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    const data = await getLogin({ userName, password })
    console.log("data", data)
    if (data?.status !== "Success") {
      let message = data.message
      showToast("error", message)
    } else {
      navigate("/registration")
      const userData = {
        isUserLoggedIn: true,
        userId: "123",
        ...data?.result?.userDetails,
      }
      dispatch(setUserData(userData))
      localStorage.setItem("accessToken", data?.result.accessToken)
      localStorage.setItem("userData", JSON.stringify(userData))
    }

    setIsLoading(false)
  }

  const onChangeUser = (e) => {
    let value = e.target.value
    value = (value.trim())?.toLowerCase()
    setUserName(value)
  }

  const handleClickForgotPassword = () => {
    navigate("/forgotPassword")
  }

  return (
    <Box className="login-wrapper">
      <Box className="login-container">
        {/* Left Sidebar with Background */}
        <Box className="sidebar-container" />

        {/* Login Form */}
        <Box className="form-container">
          {isLoading && <Loader />}
          <form onSubmit={handleSubmit} className="login-form">
            <img
              src="https://ayrshireeyeclinic.com/wp-content/uploads/2022/12/ayrshire-eye-clinic-400.png"
              className="logo"
            />
            <h1 className="form-header">Login</h1>

            <FormControl fullWidth>
              <FormLabel htmlFor="username" className="input-label">
                Username <span className="required">*</span>
              </FormLabel>
              <OutlinedInput
                id="username"
                size="small"
                value={userName}
                onChange={onChangeUser}
                required
              />
            </FormControl>

            <FormControl fullWidth margin="normal">
              <FormLabel htmlFor="password" className="input-label">
                Password <span className="required">*</span>
              </FormLabel>
              <OutlinedInput
                id="password"
                size="small"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                sx={{ padding: "0px !important" }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            <Typography
              onClick={handleClickForgotPassword}
              variant="subtitle1"
              color="secondary"
              sx={{ textDecoration: "none", cursor: "pointer" }}
            >
              Forgot Password?
            </Typography>

            <Button
              type="submit"
              variant="contained"
              className="submit-button"
              disabled={!enableLogin}
              sx={!enableLogin && { color: "gray" }}
            >
              Login
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  )
}

export default Login
